/**
 *
 * @param url
 * @param query
 * @returns path+query+hashの文字列
 */
export const getPathWithQueryAdd = (url: string, query: string): string => {
  const _url = new URL(url);
  const _searchParams = new URLSearchParams(query);
  _searchParams.forEach((value, key) => {
    _url.searchParams.set(key, value);
  });
  return `${_url.pathname}${_url.search}${_url.hash}`;
};
